'use client';

import { type MobileWebChoice, safeNext, writeMobileWebChoice } from 'BomdisoftComponents/get-the-app/gate';
import { GetTheApp } from 'BomdisoftComponents/get-the-app/index';
import type { MobileAppProduct } from 'BomdisoftComponents/store-badges/listings';
import { getLanguageFromLocale } from '@bomdisoft/translations';
import { useParams, useSearchParams } from 'next/navigation';

export type GetTheAppRouteProps = {
  logoSrc: string;
  product: MobileAppProduct;
  productName: string;
  testId?: string;
};

export const GetTheAppRoute = ({ logoSrc, product, productName, testId }: GetTheAppRouteProps) => {
  const params = useParams();
  const search = useSearchParams();
  const lang = typeof params.lang === 'string' ? params.lang : 'en';
  const os = search.get('os') === 'ios' ? 'ios' : 'android';
  const next = safeNext(search.get('next'), lang);
  const handleChoose = (choice: MobileWebChoice) => {
    writeMobileWebChoice(typeof window === 'undefined' ? undefined : window.localStorage, choice);
  };

  return <GetTheApp language={getLanguageFromLocale(lang)} logoSrc={logoSrc} next={next} onChoose={handleChoose} os={os} product={product} productName={productName} testId={testId} />;
};
